import {FC, RefObject, useCallback, useEffect, useMemo} from "react";
import {PlayIcon} from "../icons/PlayIcon";
import {StopIcon} from "../icons/StopIcon";
import {useDispatch, useSelector} from "react-redux";
import {
    selectorAudioCurrentTime,
    selectorAudioIsPlaying,
    selectorAudioPlaylistIds,
    selectorAudioPostId, selectorAudioProjectId,
    setAudioIsPlaying
} from "../reducers/AudioSlice";
import {NextIcon} from "../icons/NextIcon";
import {LayoutConst} from "../../../../core";
import {Colors, FlexBox, useBreakpoint} from "@brg/ui";
import styled, {css} from "styled-components";
import {useGetPodcastLongreadProps} from "../hooks/useGetPodcastLongreadProps";

const PlayIconWrapper = styled.div`
    cursor: pointer;
    width: 28px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`

const NextIconWrapper = styled.div<{ disabled?: boolean, isNext?: boolean }>`
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    cursor: ${({disabled}) => disabled ? 'auto' : 'pointer'};

    ${({ isNext }) => isNext && css`
        transform: scale(-1);
    `}
    
    svg {
        path {
            fill: ${({disabled}) => disabled ? Colors.galBlack21 : Colors.galBlack47}
        }
    }
`

export const PlayComponent: FC<{audioRef: RefObject<HTMLAudioElement>, hidden?: boolean}> = ({audioRef, hidden}) => {

    const isPlaying = useSelector(selectorAudioIsPlaying)
    const dispatch = useDispatch()
    const is744BP = useBreakpoint(LayoutConst.screen.s)
    const playlistIds = useSelector(selectorAudioPlaylistIds)
    const postId = useSelector(selectorAudioPostId)
    const currentTime = useSelector(selectorAudioCurrentTime)
    const projectId = useSelector(selectorAudioProjectId)
    const podcastProps = useGetPodcastLongreadProps(projectId)

    const togglePlayPause = useCallback((e: any) => {
        e.stopPropagation();
        dispatch(setAudioIsPlaying(!isPlaying))
    }, [isPlaying])

    const playListIndex = useMemo(() => playlistIds?.findIndex(playlistId => playlistId === postId), [postId, playlistIds])
    const isPrevDisabled = useMemo(() => playListIndex <= 0, [playListIndex])
    const isNextDisabled = useMemo(() => (playlistIds?.length - 1) <= playListIndex, [playListIndex, playlistIds])

    const togglePlayPrev = useCallback((e: any) => {

        if (!audioRef?.current) return;

        if (currentTime > 3 || isPrevDisabled) {
            audioRef.current.currentTime = 0;
            return;
        }

        podcastProps.onPodcastPlay(playlistIds[playListIndex - 1], playlistIds.map(id => ({postId: id})))

    }, [isPlaying, currentTime, audioRef?.current, playlistIds, isPrevDisabled, podcastProps, playListIndex])

    const togglePlayNext = useCallback((e: any) => {
        if (isNextDisabled) return;

        podcastProps.onPodcastPlay(playlistIds[playListIndex + 1], playlistIds.map(id => ({postId: id})))
    }, [isPlaying, isNextDisabled, podcastProps, playlistIds, playListIndex])

    useEffect(() => {
        if (!audioRef?.current) return;
        if (isPlaying) {
            audioRef.current.play();
        } else {
            audioRef.current.pause();
        }
    }, [isPlaying, audioRef])

    return <FlexBox style={{gap: is744BP ? '8px' : '8px'}} align="center">
        {(!hidden || !is744BP) && <NextIconWrapper disabled={!audioRef?.current} onClick={togglePlayPrev}>
            <NextIcon/>
        </NextIconWrapper>}
        <PlayIconWrapper onClick={togglePlayPause}>
            {isPlaying ? <StopIcon/> : <PlayIcon/>}
        </PlayIconWrapper>
        {(!hidden || !is744BP) && <NextIconWrapper isNext disabled={isNextDisabled || !audioRef?.current} onClick={togglePlayNext}>
            <NextIcon/>
        </NextIconWrapper>}
    </FlexBox>
}import {FC, RefObject, useCallback, useEffect, useMemo} from "react";
import {PlayIcon} from "../icons/PlayIcon";
import {StopIcon} from "../icons/StopIcon";
import {useDispatch, useSelector} from "react-redux";
import {
    selectorAudioCurrentTime,
    selectorAudioIsPlaying,
    selectorAudioPlaylistIds,
    selectorAudioPostId, selectorAudioProjectId,
    setAudioIsPlaying
} from "../reducers/AudioSlice";
import {NextIcon} from "../icons/NextIcon";
import {LayoutConst} from "../../../../core";
import {Colors, FlexBox, useBreakpoint} from "@brg/ui";
import styled, {css} from "styled-components";
import {useGetPodcastLongreadProps} from "../hooks/useGetPodcastLongreadProps";

const PlayIconWrapper = styled.div`
    cursor: pointer;
    width: 28px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`

const NextIconWrapper = styled.div<{ disabled?: boolean, isNext?: boolean }>`
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    cursor: ${({disabled}) => disabled ? 'auto' : 'pointer'};

    ${({ isNext }) => isNext && css`
        transform: scale(-1);
    `}
    
    svg {
        path {
            fill: ${({disabled}) => disabled ? Colors.galBlack21 : Colors.galBlack47}
        }
    }
`

export const PlayComponent: FC<{audioRef: RefObject<HTMLAudioElement>, hidden?: boolean}> = ({audioRef, hidden}) => {

    const isPlaying = useSelector(selectorAudioIsPlaying)
    const dispatch = useDispatch()
    const is744BP = useBreakpoint(LayoutConst.screen.s)
    const playlistIds = useSelector(selectorAudioPlaylistIds)
    const postId = useSelector(selectorAudioPostId)
    const currentTime = useSelector(selectorAudioCurrentTime)
    const projectId = useSelector(selectorAudioProjectId)
    const podcastProps = useGetPodcastLongreadProps(projectId)

    const togglePlayPause = useCallback((e: any) => {
        e.stopPropagation();
        dispatch(setAudioIsPlaying(!isPlaying))
    }, [isPlaying])

    const playListIndex = useMemo(() => playlistIds?.findIndex(playlistId => playlistId === postId), [postId, playlistIds])
    const isPrevDisabled = useMemo(() => playListIndex <= 0, [playListIndex])
    const isNextDisabled = useMemo(() => (playlistIds?.length - 1) <= playListIndex, [playListIndex, playlistIds])

    const togglePlayPrev = useCallback((e: any) => {

        if (!audioRef?.current) return;

        if (currentTime > 3 || isPrevDisabled) {
            audioRef.current.currentTime = 0;
            return;
        }

        podcastProps.onPodcastPlay(playlistIds[playListIndex - 1], playlistIds.map(id => ({postId: id})))

    }, [isPlaying, currentTime, audioRef?.current, playlistIds, isPrevDisabled, podcastProps, playListIndex])

    const togglePlayNext = useCallback((e: any) => {
        if (isNextDisabled) return;

        podcastProps.onPodcastPlay(playlistIds[playListIndex + 1], playlistIds.map(id => ({postId: id})))
    }, [isPlaying, isNextDisabled, podcastProps, playlistIds, playListIndex])

    useEffect(() => {
        if (!audioRef?.current) return;
        if (isPlaying) {
            audioRef.current.play();
        } else {
            audioRef.current.pause();
        }
    }, [isPlaying, audioRef])

    return <FlexBox style={{gap: is744BP ? '8px' : '8px'}} align="center">
        {(!hidden || !is744BP) && <NextIconWrapper disabled={!audioRef?.current} onClick={togglePlayPrev}>
            <NextIcon/>
        </NextIconWrapper>}
        <PlayIconWrapper onClick={togglePlayPause}>
            {isPlaying ? <StopIcon/> : <PlayIcon/>}
        </PlayIconWrapper>
        {(!hidden || !is744BP) && <NextIconWrapper isNext disabled={isNextDisabled || !audioRef?.current} onClick={togglePlayNext}>
            <NextIcon/>
        </NextIconWrapper>}
    </FlexBox>
}